import { EditableTitle } from '@/components/Title/EditableTitle';
import { useGetTranslationGroup, useUpdateTranslationGroup } from '@/state/translations';
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { useCurrentDraftGroupId } from '../hooks/useCurrentDraftGroupId';

const VideoTitleInput = styled(EditableTitle)`
    color: ${({ theme }) => theme.colors.black[700]};
    font-weight: 500;
`;

interface IProps {
    fontSize?: number;
    className?: string;
    staticWidth?: boolean;
}

function TitleInput({ fontSize = 14, className, staticWidth }: IProps) {
    const groupId = useCurrentDraftGroupId();
    const { data: group } = useGetTranslationGroup(groupId!);
    const [videoName, setVideoName] = useState<string>('');
    const { mutateAsync: updateGroup } = useUpdateTranslationGroup({ onError: handleTitleUpdateError });

    useEffect(() => {
        if (group?.name) {
            setVideoName(group.name);
        }
    }, [group?.name]);

    async function handleTitleBlur(value: string) {
        if (group?.name !== value) {
            await updateGroup({ id: groupId, name: value });
        }
    }

    function handleTitleUpdateError() {
        setVideoName(group?.name || '');
    }

    return (
        <VideoTitleInput
            showIcon
            testId="translation-header-video-title-input"
            staticWidth={staticWidth}
            className={className}
            fontSize={fontSize}
            value={videoName}
            onChange={setVideoName}
            onBlur={handleTitleBlur}
        />
    );
}

export default TitleInput;
